import React, { useState } from "react";
import { isValuePresent } from "../../../utils/builderUtils";

const CFCheckbox = ({ label, rightLabel, callback, defaultChecked = false, checked, ...props }) => {
  const [internalChecked, setInternalChecked] = useState(defaultChecked);
  const isChecked = checked !== undefined ? checked : internalChecked;

  const handleChange = (e) => {
    const newChecked = e.target.checked;

    if (checked === undefined) {
      setInternalChecked(newChecked);
    }

    if (callback) callback(newChecked);
  };

  return (
    <div className="flex items-center justify-between w-full">
      <label className="text-xl flex items-center gap-2 m-0 cursor-pointer max-w-[90%]">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleChange}
          className="appearance-none !m-0 w-6 h-6 rounded-lg border-solid border-1 !border-slate-300 bg-white transition !has-checked:bg-black cursor-pointer checked:bg-blue-600 checked:border-blue-600"
          {...props}
        />
        <span className="whitespace-nowrap text-ellipsis overflow-hidden">{label}</span>
      </label>

      {isValuePresent(rightLabel) ? <span className="text-xl text-gray-500 m-0">{rightLabel}</span> : null}
    </div>
  );
};

export default CFCheckbox;
